import get from 'lodash/get'
import {
  IFederatedStateCodes,
  ILocationFilterInput,
  IShipmentStopRegionTypes,
  Maybe,
} from 'types/graphqlTypes'
import { Region } from 'apps/marketplace/apiTypes/shipperRates'

export interface IGetLocationFilterInput {
  city: Maybe<string>
  stateCode: Maybe<string>
  radius: Maybe<number>
  regions: Maybe<Region[]>
  searchType: Maybe<string>
}

export const getLocationFilter = ({
  city,
  radius,
  regions,
  searchType,
  stateCode,
}: IGetLocationFilterInput): ILocationFilterInput => {
  const stateCodeParam = get(IFederatedStateCodes, stateCode || '')

  const includeDatMarketSearchParam = city && stateCode && !regions
  const isDatMarketSearch = searchType === 'dat_markets'

  const radiusParam = { value: radius || 0 }

  const regionParam = (regions || []).map(region => get(IShipmentStopRegionTypes, region))

  return {
    ...(city ? { city } : {}),
    ...(stateCode ? { stateCode: stateCodeParam } : {}),
    ...(includeDatMarketSearchParam ? { isDatMarketSearch } : {}),
    ...(radius ? { radius: radiusParam } : {}),
    ...(regions && regions.length ? { regions: regionParam } : {}),
  }
}
